import React, { Component } from 'react';
import { connect } from 'react-redux';

import { history } from '../../../store';

import LoadingIcon from '../../common/icons/LoadingIcon';

import styles from './_styles/DdnySearch.module.scss';

import * as ddnyActionCreators from '../../../actions/ddny';
import AttributeSelect from './blocks/AttributeSelect';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class DdnySearch extends Component {

	constructor(props) {
		
		super(props);

		this.state = {

			requestPending: false,

			inputQuick: this.props.ddny?.filters?.q || '',
			inputAttributes: this.objectifyAttributeString(this.props.ddny?.filters?.attributes) || {},
		};
	}

	componentDidMount() {
		this.fetchAttributes();
	}

	async fetchAttributes() {
		if(this.props.ddny.attributes === null) {
			this.setState({ requestPending: true });
			try {
				await this.props.ddnyFetchAttributes();
			} catch(err) {
				console.error(err);
			} finally {
				this.setState({ requestPending: false });
			}
		}
	}

	formatAttributes() {
		const result = Object.entries(this.state.inputAttributes)
			.map(([key, value]) => `${key}:${value}`)
			.join(";");
		return result;
	}

	objectifyAttributeString(attrStr) {
		if(!attrStr) { return null; }
		try {
			const obj = attrStr.split(";").reduce((acc, pair) => {
				const [key, value] = pair.split(":");
				acc[key] = value;
				return acc;
			}, {});
			return obj;
		} catch(err) {
			return null;
		}
	}
	
	handleSubmit(evt) {
		if(evt) {evt.preventDefault(); }

		const searchFilters = {
			page: 1,
			size: 60,
		};

		if(this.state.inputQuick) {
			searchFilters['q'] = this.state.inputQuick;
		}

		const attrValue = this.formatAttributes();
		if(attrValue) {
			searchFilters['attributes'] = attrValue;
		}

		this.props.ddnySetFilters(searchFilters);

		history.push('/ddny/gallery');
	}

	handleInputChange(evt) {
		this.setState({ inputQuick: evt.target.value });
	}
	
	handleAttributeChange(typeKey, attrValue) {
		this.setState({ inputAttributes: { 
			...this.state.inputAttributes,
			[typeKey]: attrValue || '',
		}});
	}

	resetSearch() {
		this.setState({
			inputQuick: '',
			inputAttributes: {},
		}, () => {
			this.props.ddnySetFilters({});
		});
	}

	render() {
		return <div className={styles.DdnySearch}>
			<div className={styles.searchWrapper}>
				<div className={styles.titleWrapper}>
					<div className={styles.title}>Search DDNY Jewelry</div>
				</div>
				<form className={styles.searchForm} onSubmit={this.handleSubmit.bind(this)}>
					
					<div className={styles.sectionWrapper}>
						<div className={styles.sectionBody}>
							<div className={styles.heroSearchWrapper}>
								<input
									type='text'
									placeholder='Search DDNY jewelry'
									value={this.state.inputQuick}
									onChange={this.handleInputChange.bind(this)} />
								<button 
									type='submit'
									className={styles.inputSubmit}>
									Search
								</button>
							</div>
						</div>
					</div>

					<div className={styles.sectionWrapper}>
						<div className={styles.sectionTitle}>Jewelry Attributes</div>
						<div className={styles.sectionBody}>
							{this.state.requestPending
								?	<div className={styles.loading}>
										<div className={styles.iconWrapper}>
											<LoadingIcon />
										</div>
									</div>
								: 	<div className={styles.loaded}>
										<div className={styles.attributes}>
											{this.props.ddny.attributes?.map((attrObj, i) => {
												if(!attrObj.attributes?.length) {
													return null;
												}

												return <div key={i} className={styles.attrWrapper}>
													<AttributeSelect
														attributeType={attrObj.type}
														attributeOptions={attrObj.attributes}
														value={this.state.inputAttributes[attrObj.type.key] || ''}
														onChange={this.handleAttributeChange.bind(this)} />
												</div>
											})}
										</div>
									</div>
							}
						</div>
					</div>

					<div className={styles.actionRow}>
						<button 
							type='submit'
							className={`${styles.submitAction} actionButton`}>
							Search
						</button>
						
						<div className={styles.resetLink} onClick={this.resetSearch.bind(this)}>Reset Search</div>

					</div>

				</form>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {
		ddny: state.ddny,
	};
}

export default connect(mapStateToProps, allActionCreators)(DdnySearch);